import {takeLatestF, showError} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {Config} from 'app/config';
import * as routerActions from 'app/router';
import {appRoutePaths} from 'app/routes/route-paths';
import {logger} from 'app/sentry-logger';
import {history} from 'app/setup/history';
import {t} from 'app/translations';

import {userRoutePaths} from '../../routes/route-paths';
import {LogOutAction, userAction} from '../action';
import {simpleUserSelector} from '../selector';
import {buildLoginRouteState} from './saga-utils';

const te = t('user');

const title = te('logout');
export function* execute({payload: {goToLogin, sessionExpired}}: LogOutAction): SagaIterator {
    const currentUser = yield* select(simpleUserSelector.currentUser);

    const {location} = history;
    const shouldGoToLogin = Boolean(goToLogin) && location.pathname !== userRoutePaths.login;
    const shouldGoHome = !goToLogin && location.pathname === userRoutePaths.logout;
    let routeState;

    if (goToLogin && location.pathname !== userRoutePaths.logout) {
        routeState = yield* select(buildLoginRouteState);
    }

    logger.setAnonymousUser();

    if (currentUser.isFull && !sessionExpired) {
        const response = yield* call(Api.logout);

        if (!response.isSuccess) yield* put(showError(title, te('unexpectedErrorWhileLogout')));

        if (!Config.disableLegacyLogin) {
            const legacyResponse = yield* call(Api.logoutLegacy);

            if (!legacyResponse.isSuccess && legacyResponse.data !== '') {
                yield* put(showError(title, te('unexpectedErrorWhileLegacyLogout')));
            }
        }
    }

    yield* put(userAction.logOutClear());

    if (shouldGoToLogin) {
        yield* put(routerActions.push(userRoutePaths.login, routeState));
    } else if (shouldGoHome) {
        yield* put(routerActions.push(appRoutePaths.home));
    }
}

export function* logoutSaga(): SagaIterator {
    yield takeLatestF('user/LOGOUT', execute);
}
